<template>
	<van-sticky @change="handleStickyChange">
		<page-header :style="{ background: sticky ? stickyBgColor : bgColor }" />
		<van-nav-bar :style="{ background: sticky ? stickyBgColor : bgColor }" :border="border"
			@click-left="handleClickLeft" @click-right="$emit('click-right')">
			<template #left v-if="leftShow">
				<img class="back-icon" :src="require(`@/assets/images/${leftSrc}`)" />
			</template>
			<template #title>
				<span class="leftText" :style="leftStyle">{{ leftText }}</span>
				<slot name="title" />
				<div class="title" :style="{ color: titleColor || '#171a1d' }">{{ title }}</div>
			</template>
			<template #right>
				<slot name="right" />
			</template>
		</van-nav-bar>
		<slot name="extend" />
	</van-sticky>
</template>

<script>
import { NavBar, Sticky } from "vant";
export default {
	name: 'nav-bar',
	components: {
		[NavBar.name]: NavBar,
		[Sticky.name]: Sticky,
	},
	data() {
		return {
			sticky: false,
		};
	},
	props: {
		title: String,
		// 展示左侧返回
		leftShow: {
			type: Boolean,
			default: true,
		},
		// 左侧文字
		leftText: String,
		leftStyle: Object,
		// 标题颜色
		titleColor: String,
		leftSrc: {
			type: String,
			default: "home/goodsDetail/back.png",
		},
		// 背景颜色
		bgColor: {
			type: String,
			default: "transparent",
		},
		// 吸顶后背景
		stickyBgColor: {
			type: String,
			default: "transparent",
		},
		border: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		/** 吸顶状态更改 */
		handleStickyChange(isFixed) {
			this.sticky = isFixed;
			this.$emit('change', isFixed)
		},
		/** 左侧点击，优先自定义事件，否则返回上一页 */
		handleClickLeft() {
			if (this.$listeners['click-left']) {
				this.$emit('click-left');
			} else {
				this.$router.back();
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.back-icon {
	width: 32px;
	height: 32px;
}

::v-deep .van-nav-bar--fixed {
	z-index: 100;
}

::v-deep .van-nav-bar__left {
	padding-left: 10px;
}

::v-deep .van-nav-bar__right {
	padding-right: 10px;
}

::v-deep .van-nav-bar__title {
	margin: 0;
}

.title {
	font-size: 16px;
	font-weight: 600;
	line-height: 18px;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}

.leftText {
	font-size: 16px;
	line-height: 18px;
	color: #171a1d;
	font-weight: 600;
	margin-left: 42px;
}

::v-deep .van-nav-bar__right:active {
	opacity: 1;
}
</style>